'use strict';

import {PriebezneHodnotenie} from './PriebezneHodnotenie';

export class PriebezneHodnotenieGroup {

  constructor(h: PriebezneHodnotenie) {
    this.id = h.id;
    this.name = h.predmetNazov;
    this.skratka = h.predmetSkratka;
    this.bodyUdelene = h.pocetBodov;
    this.items.push(h);
    this.kodSemester = h.kodSemester;

    this.bodyZiskane = this.calculateBodyZiskane(h);
    this.podmieneneDovodyCount = this.calculatePodmieneneDovody(h);
    this.podmieneneZiskaneDovodyCount = this.calculatePodmieneneZiskaneDovody(h);

    this.bodyNavrhovane = this.calculateBodyNavrhovane();
  }

  id: number;
  name: string;
  skratka: string;
  bodyUdelene: number;
  bodyZiskane: number;
  bodyNavrhovane: number;
  kodSemester: string;
  items: PriebezneHodnotenie[] = [];
  podmieneneDovodyCount: number;
  podmieneneZiskaneDovodyCount: number;

  addItem(h: PriebezneHodnotenie) {
    this.bodyUdelene += h.pocetBodov;
    this.bodyZiskane += this.calculateBodyZiskane(h);
    this.podmieneneDovodyCount += this.calculatePodmieneneDovody(h);
    this.podmieneneZiskaneDovodyCount += this.calculatePodmieneneZiskaneDovody(h);

    this.bodyNavrhovane = this.calculateBodyNavrhovane();

    this.items.push(h);
  }

  private calculateBodyZiskane(h: PriebezneHodnotenie) {
    if (h.zapocitat && h.pocetBodov !== null) {
      if (h.minHranica == null || (h.pocetBodov > h.minHranica)) {
        return h.pocetBodov < h.hranica ? h.pocetBodov : h.hranica;
      }
    }
    return 0;
  }

  private calculatePodmieneneDovody(h: PriebezneHodnotenie): number {
    return (h.zapocitat && h.minHranica !== null ) ? 1 : 0;
  }

  private calculatePodmieneneZiskaneDovody(h: PriebezneHodnotenie): number {
    if (h.zapocitat && h.pocetBodov !== null ) {
      if (h.pocetBodov > h.minHranica) {
          return 1;
      }
    }
    return 0;
  }

  private calculateBodyNavrhovane(): number {
    return this.podmieneneDovodyCount > this.podmieneneZiskaneDovodyCount ? 0 : this.bodyZiskane;
  }
}
